import { render, staticRenderFns } from "./wizard3.vue?vue&type=template&id=1616aeec"
import script from "./wizard3.vue?vue&type=script&lang=js"
export * from "./wizard3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/product/wizard3.vue
// module id = null
// module chunks = 